import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';
import { always, append, compose, uniq, without, equals } from 'ramda';
import { BookingStep } from '../../routes/booking/booking.constants';
import { PaymentStatus } from './booking.constants';

export const { Types: BookingTypes, Creators: BookingActions } = createActions(
  {
    startBooking: null,
    closeBooking: null,
    clearBooking: null,
    nextStep: null,
    requestNextStep: ['data'],
    previousStep: null,
    selectSlot: ['slot'],
    unselectSlot: ['slot'],
    selectDate: ['date'],
    setNotes: ['notes'],
    setTicketsCount: ['ticketType', 'count'],
    setCode: ['code'],
    setPaymentStatus: ['status'],
    paymentTokenReceived: ['token'],
  },
  { prefix: 'BOOKING_' }
);

export const INITIAL_STATE = Immutable({
  isBookingActive: false,
  step: BookingStep.TIME,
  timeSlots: [],
  date: null,
  notes: '',
  tickets: {},
  code: null,
  paymentStatus: PaymentStatus.INITIAL,
});

const handleStartBooking = state => state.set('isBookingActive', true);
const handleNextStep = state => state.update('step', step => Math.min(3, step + 1));
const handlePreviousStep = state => state.update('step', step => Math.max(0, step - 1));
const handleSlotSelected = (state, { slot }) =>
  state.update(
    'timeSlots',
    compose(
      uniq,
      append(slot)
    )
  );
const handleSlotUnselected = (state, { slot }) => state.update('timeSlots', without([slot]));
const handleDateSelected = (state, { date }) => state.set('date', date).set('timeSlots', []);
const handleSetNotes = (state, { notes }) => state.set('notes', notes);
const handleSetTicketsCount = (state, { ticketType, count }) => {
  const tickets = state.tickets.set(ticketType, count).without(equals(0));
  return state.set('tickets', tickets);
};
const handleClearBooking = always(INITIAL_STATE);
const handleSetCode = (state, { code }) => state.merge({ code });
const handleSetPaymentStatus = (state, { status }) => state.merge({ paymentStatus: status });

export const reducer = createReducer(INITIAL_STATE, {
  [BookingTypes.START_BOOKING]: handleStartBooking,
  [BookingTypes.NEXT_STEP]: handleNextStep,
  [BookingTypes.PREVIOUS_STEP]: handlePreviousStep,
  [BookingTypes.SELECT_SLOT]: handleSlotSelected,
  [BookingTypes.UNSELECT_SLOT]: handleSlotUnselected,
  [BookingTypes.SELECT_DATE]: handleDateSelected,
  [BookingTypes.SET_NOTES]: handleSetNotes,
  [BookingTypes.SET_TICKETS_COUNT]: handleSetTicketsCount,
  [BookingTypes.CLEAR_BOOKING]: handleClearBooking,
  [BookingTypes.SET_CODE]: handleSetCode,
  [BookingTypes.SET_PAYMENT_STATUS]: handleSetPaymentStatus,
});
